module.exports = __webpack_public_path__ + "static/5-5055b9aa3e1cca504d4ab978bbeeaca6.jpg";